export const nigerianStates = [
    { code: 1, title: 'ABIA' },
    { code: 35, title: 'YOBE' },
    { code: 36, title: 'ZAMFARA' },
    { code: 37, title: 'ABUJA' }
]

export const localGovernments = [
    { code: 101, stateCode: 1, title: 'UKWUWUANO' },
    { code: 35, stateCode: 1, title: 'YOBE' },
    { code: 102, stateCode: 35, title: 'ISIALA-NGWA NORTH' },
    { code: 103, stateCode: 35, title: 'ISIALA-NGWA SOUTH' },
    { code: 104, stateCode: 36, title: 'ISUIKWATO' },
    { code: 105, stateCode: 36, title: 'NGWA' },
    { code: 106, stateCode: 37, title: 'OBI NWA' },
    { code: 107, stateCode: 37, title: 'MENI ABA' }
]

export const nigerianLocalGovernments = [
    'Zaria',
    'Samaru',
    'Sabon Tasha'
]

export const aLevelCourses = [
    { courseName: 'Science A', courseCode: '100' },
    { courseName: 'Art A', CourseCode: '200' }
]

export const oLevelCourses = [
    { courseName: 'English', courseCode: '1' },
    { courseName: 'Mathematics', courseCode: '2' }
]

// Basic country list (can be extended as needed)
export const countries = [
    { code: 'NG', name: 'Nigeria' },
    { code: 'GH', name: 'Ghana' },
    { code: 'ZA', name: 'South Africa' },
    { code: 'US', name: 'United States' },
    { code: 'CA', name: 'Canada' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'DE', name: 'Germany' },
    { code: 'FR', name: 'France' },
    { code: 'IT', name: 'Italy' },
    { code: 'ES', name: 'Spain' },
    { code: 'BR', name: 'Brazil' },
    { code: 'IN', name: 'India' },
    { code: 'CN', name: 'China' },
    { code: 'JP', name: 'Japan' },
    { code: 'AU', name: 'Australia' },
    { code: 'KE', name: 'Kenya' },
    { code: 'EG', name: 'Egypt' },
    { code: 'SA', name: 'Saudi Arabia' },
    { code: 'AE', name: 'United Arab Emirates' }
]